/** Strip currency formatting from pasted/edited target values. */
export function parseTargetInput(raw: string): number | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;

  const normalized = trimmed.replace(/[\s,$]/g, "");
  if (normalized.startsWith("-") || normalized.startsWith("(")) return null;

  const cleaned = normalized.replace(/[^\d.]/g, "");
  if (!cleaned || cleaned === ".") return null;

  const n = Number(cleaned);
  if (Number.isNaN(n) || n < 0) return null;

  return n;
}

export function isTargetInputInvalid(raw: string): boolean {
  const trimmed = raw.trim();
  if (!trimmed) return false;
  return parseTargetInput(raw) == null;
}
